<div class="flex flex-wrap align-items-center justify-content-center w-full mb-6">

    <ngx-loading [show]="(loadingService.isLoading$ | async) || false"></ngx-loading>

    <div class="mt-2 mx-4 w-full md:w-10 lg:w-8 xl:w-8">
        <div class="h-3rem flex flex-row-reverse">
            <p-speedDial [model]="languages" direction="down" showIcon="" hideIcon="" onClick="e => console.log(e)"
                [buttonClassName]="language.id">
            </p-speedDial>
        </div>

        <router-outlet></router-outlet>
    </div>
</div>

<footer class="footer bgc-dark text-white">
    <div class="container">
        <div class="copyright text-center flex align-items-end justify-content-center gap-2">
            <img alt="i-host" width="64" class="footer-logo" src="assets/images/logo-white.png">
            © 2016 - {{ currentDate | date: 'yyyy' }}. All rights reserved.
        </div>
    </div>
</footer>